import React, { useCallback } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { isPhone, isPhoneNative } from '@helpers';
import EditableLine from '@components/common/editableLine';
import { useFocusEffect } from '@react-navigation/native';
import InputLine from './InputLine';

export default ({
  C,
  data,
  scale = initialScale,
  font = initialFont,
  noMachine,
  bg,
  isEditModeForPartSwitchOn,
  partId,
  setEditingPartData,
  editingPartData,
}) => {
  useFocusEffect(
    useCallback(() => {
      const partDetails = data.reduce((acc, i) => {
        if (i?.key) {
          acc[i?.key] = i.value ?? i.valueInTextFormat;
        }
        return acc;
      }, {});

      setEditingPartData(partId, partDetails);
    }, [])
  );

  const updateData = (key, value) => {
    setEditingPartData(partId, { ...editingPartData.partDetails, [key]: value });
  };

  return (
    <View style={{ width: '100%', height: scale(42) * data.length + 2 }}>
      {data.map((i, index) => {
        const shouldDisplayInputLine = !!i?.ValueComponent || isPhoneNative; //TODO: this is hot fix to fix UI for parts for mobile. Because Editable Line here is break UI. Fix this later properly.

        if (shouldDisplayInputLine) {
          return (
            <InputLine
              {...{
                bg,
                data,
                index,
                i,
                C,
                font,
                scale,
                borderBottomRadius: index === data.length - 1,
                borderTopRadius: index === 0 && noMachine && !isPhone,
              }}
              key={i.name}
            />
          );
        }

        return (
          <EditableLine
            key={i.name}
            {...{
              bg,
              array: data,
              index,
              item: {
                ...i,
                value: isEditModeForPartSwitchOn ? editingPartData?.partDetails?.[i?.key] ?? i.value ?? '' : i.value ?? '',
                oneLine: true,
                onChange: (value) => updateData(i.key, value),
                small: false,
              },
              C,
              font,
              scale,
              topBorder: false,
              bottomBorder: index !== data.length - 1,
              roundTop: index === 0 && noMachine && !isPhone,
              roundBottom: index === data.length - 1,
              editable: isEditModeForPartSwitchOn,
              threeColumns: true,
              threeColumnsForText: true,
              withoutPaddingLeft: true,
              withoutPressHoverColor: true,
              withoutPositionAbsolute: true,
            }}
          />
        );
      })}
    </View>
  );
};
